@if (!printing()) {
<div class="footer">
  <div class="footer__contact">
    <div class="footer__contact-details">
      @if (partner().code) {
      <span>
        {{ partner().address }} <br />
        <a href="tel:+{{ partner().phone }}">{{ phoneDisplay() }}</a><br />
        <a href="mailto:{{ partner().email }}">{{ partner().email }}</a>
      </span>
      }
      @else {
      <span>
        <a href="tel:+4842544141">484.254.4141</a><br />
        <a href="mailto:support@lakehouse-analytics.com">support&#64;lakehouse-analytics.com</a>
      </span>
      }
    </div>
    <div class="footer__contact-copyright">
      &copy; {{ copyrightYear }} LakeHouse Analytics. All rights reserved.
    </div>
  </div>
  <div class="footer__links">
    <div>
      <a routerLink="/privacy">Privacy Policy</a> | <a routerLink="/terms">Terms of Use</a>
    </div>
    @if (partner().code) {
    <div>
      <a class="logo" href="https://lakehouse-analytics.com" target="_blank">
        <img class="logo" src="/assets/img/logo-poweredby.svg" width="200">
      </a>
    </div>
    }
  </div>
</div>
}
